<template>
    <div>
        <block :value="loading"></block>
        <v-card class="pa-4 ma-1 white">
        <!-- Table -->
         <DateFilter ref="childRef" @reset-data="getTransfers"
            @filtered-data="handleDateFilter" :filterEndpoint="getTransfersFiltered"
            :isFilteredByOutsource="false" :search="search"
            @filtered-loading="loading = $event" />
        <GeneralFilter class="background border-box" entity="transferencia"
        :filterEndpoint="$API.inventoryTransfer.filterTransfers" :search="search"
        @emptyFilter="getTransfers" @filtered="filterHandler"
        @loading="loading = $event"
        :showAllRecords="showAllRecords">
            <template #options>
                <v-checkbox
                    :input-value="showAllRecords"
                    @change="onShowAllRecordsChange"
                    label="Mostrar todos los registros (sin límite de 100)"
                    dense
                    hide-details="auto"
                />
            </template>
            <DxDataGrid class="isScrolledByGeneralFilter" :data-source="transfer" :column-auto-width="true" key="ID_Transfer" :show-row-line="ShowRowLines" :show-border="showBorders"
                :row-alternation-enabled="rowAlternationEnabled" @exporting="onExporting" style="max-height: 600px">
                <DxExport :enabled="true" />
                <DxScrolling row-rendering-mode="virtual" />
                <DxPaging :page-size="10" />
                <DxPager :show-page-size-selector="true" :allowed-page-sizes="[10, 25, 50, 100]" :show-info="true" />
                <DxColumn :width="100" cell-template="show-template" caption="" v-if="$store.getters['rolesUser/getCustomRole'](113)"></DxColumn>
                <DxColumn data-field="ID_Transfer" caption="ID"></DxColumn>
                <DxColumn data-field="DateReq" caption="Fecha de solicitud"></DxColumn>
                <DxColumn data-field="DateTransfer" caption="Fecha de Aprobación"></DxColumn>
                <DxColumn data-field="OriginWarehouse" caption="Origen"></DxColumn>
                <DxColumn data-field="DestinyWarehouse" caption="Destino"></DxColumn>
                <DxColumn data-field="ReqName" caption="Usuario Solicita"></DxColumn>
                <DxColumn data-field="userName" caption="Usuario Aprobación"></DxColumn>
                <template #show-template="{ data }">
                    <a href="#" class="mx-1" @click.prevent.stop="showTransferDetails( data )">
                        <v-icon color="primary">mdi-eye</v-icon>
                    </a>
                </template>
            </DxDataGrid>
        </GeneralFilter>
        <!-- Table -->

        <!-- Modal -->
        <v-dialog v-model="showModal" max-width="1024px" scrollable>
            <TransferDetails v-if="transferData" @close-modal="showModal = $event" @reload-table="getTransfers" :transferData="transferData" :key="transferData.data.ID_Transfer" delete-allowed />
        </v-dialog>
        <!-- Modal -->
        </v-card>
    </div>
</template>

<script>
import { DxDataGrid, DxExport, DxColumn, DxScrolling, DxPaging, DxPager } from 'devextreme-vue/data-grid'
import { formatDate } from '../../../helpers/formatDate'
import { printToExcel } from "../../../helpers/printToexcel"
import TransferDetails from '../TransferDetails.vue'
import GeneralFilter from '@/components/GeneralFilter.vue'
import DateFilter from '../../../components/DateFilter.vue'
export default {
    name: 'SearchTransferTable',

    components: {
        DxDataGrid,
        DxColumn,
        DxExport,
        DxScrolling,
        DxPaging,
        DxPager,
        TransferDetails,
        GeneralFilter,
        DateFilter,
    },

    props: ['win'],

    data() {
        return {
            ShowRowLines: true,
            showBorders: true,
            rowAlternationEnabled: true,
            showModal: false,
            transfer: [],
            transferData: null,
            showAllRecords: false,
            loading: false,
            search: {
                filter: null
            }
        }
    },

    methods: {
        async showTransferDetails(data) {
            if (this.loading) return;

            this.loading = true;
            try {
                const detail = await this.$API.inventoryTransfer.getOneTransfer(
                    data.data.ID_Transfer
                );

                this.transferData = {
                    ...data,
                    data: {
                        ...data.data,
                        ...detail,
                        TransferDate: data.data.TransferDate || formatDate(detail.TransferDate)
                    }
                };
                this.showModal = true;
            } catch (error) {
                console.log(error);
            } finally {
                this.loading = false;
            }
        },
        onExporting(e) {
            printToExcel(e, 'Transferencias de inventario')
        },
        // Método para filtrar por fechas desde DateFilter
        async getTransfersFiltered(params) {
            const { start, end } = params;
            const response = await this.$API.inventoryTransfer.filterTransfers({
                ...this.search,
                startDate: start,
                endDate: end,
                showAllRecords: this.showAllRecords
            });
            return response.map(transfer => ({
                ...transfer,
                TransferDate: formatDate(transfer.TransferDate),
            }));
        },
        handleDateFilter(filteredData) {
            // El DateFilter ya devuelve los datos formateados
            this.transfer = filteredData;
        },
        async getTransfers() {
            this.loading = true;
            try {
                const response = await this.$API.inventoryTransfer.getAllTransfersHistory({
                    showAllRecords: this.showAllRecords
                });
                this.transfer = response.map(transfer => ({
                    ...transfer,
                    TransferDate: formatDate(transfer.TransferDate),
                }));
            } catch (error) {
                console.log(error);
            } finally {
                this.loading = false;
            }
        },
        onShowAllRecordsChange(value) {
            this.showAllRecords = value;
            this.getTransfers();
        },
        filterHandler(response) {
            this.transfer = response.map(transfer => ({
                ...transfer,
                TransferDate: formatDate(transfer.TransferDate),
            }))
        },
        getAccountData() {
            this.$API.inventoryTransfer.filterTransfers(this.search)
                .then(response => {
                    this.transfer = response.map(transfer => ({
                        ...transfer,
                        TransferDate: formatDate(transfer.TransferDate),
                    }))
                })
                .catch(error => {
                    console.log(error)
                })
            // this.accountData = filteredData
            // this.loading = false
        },
    },
}
</script>
